<template>
    <label :class="isDisabled ? 'm-form-checkbox_disabled' : 'm-form-checkbox'" :data-jest="`form-checkbox-${name}`">
        <input type="checkbox" :id="name" :name="name" class="m-form-checkbox-input" v-model="inputValue" :data-jest="`form-checkbox-input-${name}`">
        <span class="m-form-checkbox-checked"></span>
        <span class="check-box-label">
            <slot>{{label}}</slot>
        </span>
    </label>
</template>

<script>
    export default {
        name: "FormCheckbox",
        props: {
            /**
             * 選択肢ラベル
             */
            label: {
                type: String,
                required: false,
                default: ''
            },
            /**
             * name属性
             */
            name: {
                type: String,
                required: true
            },
            /**
             * 初期選択設定
             */
            isDefaultChecked: {
                type: Boolean,
                required: false,
                default: false
            },
            /**
             * 非アクティブかどうか
             */
            isDisabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        emits: ['update:modelValue'],
        data() {
            return {
                inputValue: false,
            }
        },
        watch: {
            isDefaultChecked() {
                this.inputValue = this.isDefaultChecked
            },
            inputValue() {
                this.updateValue(this.inputValue)
            },
        },
        created(){
            this.inputValue = this.isDefaultChecked
        },
        methods: {
            updateValue(value) {
                this.$emit("update:modelValue", value);
            },
        }
    }
</script>

<style>
.check-box-label {
    white-space: pre-line;
}
</style>
